import EditorDisplay from '../editor/EditorDisplay';
import { AppFormLabel } from './AppFieldView';

interface RichTextDisplayProps {
	editorTheme?: 'normal' | 'style2';
	label?: string;
	editorStateString?: string;
}

export default function RichTextDisplay({
	editorTheme = 'normal',
	label,
	editorStateString: htmlString,
}: RichTextDisplayProps) {
	return (
		<>
			<AppFormLabel>{label}</AppFormLabel>
			<div style={{ width: 390 }}>
				<EditorDisplay
					editorStateString={htmlString}
					isTransparentBackground
					editorTheme={editorTheme}
				/>
			</div>
		</>
	);
}
